import { createRouter, createWebHistory } from 'vue-router'
import { useSessionStore } from '@/stores/session'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      name: 'root',
      redirect: () => {
        const store = useSessionStore()
        if (store.user) return store.isAdmin ? '/admin' : '/apps'
        return '/apps'
      },
    },
    {
      path: '/apps',
      name: 'apps',
      component: () => import('@/views/Apps.vue'),
      meta: { title: '应用列表' },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/Profile.vue'),
      meta: { title: '个人中心' },
    },
    {
      path: '/admin',
      component: () => import('@/layouts/AdminLayout.vue'),
      meta: { admin: true },
      children: [
        {
          path: '',
          name: 'adminHub',
          component: () => import('@/views/admin/Hub.vue'),
          meta: { title: '后台总览', admin: true, section: 'hub' },
        },
        { path: 'auth', redirect: '/admin/clients' },
        { path: 'overview', redirect: '/admin/clients' },
        { path: 'user', redirect: '/admin/users' },
        {
          path: 'users',
          name: 'adminUsers',
          component: () => import('@/views/admin/Users.vue'),
          meta: { title: '用户管理', admin: true, section: 'user' },
        },
        {
          path: 'org',
          name: 'adminOrg',
          component: () => import('@/views/admin/OrgTree.vue'),
          meta: { title: '组织架构', admin: true, section: 'user' },
        },
        { path: 'schools', redirect: '/admin/org' },
        { path: 'colleges', redirect: '/admin/org' },
        { path: 'depts', redirect: '/admin/org' },
        {
          path: 'positions',
          name: 'adminPositions',
          component: () => import('@/views/admin/Positions.vue'),
          meta: { title: '职位身份', admin: true, section: 'user' },
        },
        {
          path: 'stages',
          name: 'adminStages',
          component: () => import('@/views/admin/Stages.vue'),
          meta: { title: '学段年级', admin: true, section: 'user' },
        },
        {
          path: 'roles',
          name: 'adminRoles',
          component: () => import('@/views/admin/Roles.vue'),
          meta: { title: '系统角色', admin: true, section: 'user' },
        },
        {
          path: 'data-home',
          name: 'adminDataHome',
          component: () => import('@/views/admin/UserHome.vue'),
          meta: { title: '数据概览', admin: true, section: 'data' },
        },
        {
          path: 'op-logs',
          name: 'adminOpLogs',
          component: () => import('@/views/admin/Audit.vue'),
          meta: { title: '操作日志', admin: true, section: 'data' },
        },
        { path: 'user-home', redirect: '/admin/data-home' },
        { path: 'user-logs', redirect: '/admin/op-logs' },
        { path: 'audit', redirect: '/admin/op-logs' },
        {
          path: 'clients',
          name: 'adminClients',
          component: () => import('@/views/admin/Clients.vue'),
          meta: { title: '第三方应用', admin: true, section: 'auth' },
        },
        {
          path: 'clients/:clientId',
          name: 'adminClientDetail',
          component: () => import('@/views/admin/ClientDetail.vue'),
          meta: { title: '应用配置', admin: true, section: 'auth' },
        },
        {
          path: 'clients-new',
          name: 'adminClientCreate',
          component: () => import('@/views/admin/ClientDetail.vue'),
          meta: { title: '新增应用', admin: true, section: 'auth' },
        },
      ],
    },
  ],
})

router.beforeEach(async (to) => {
  const store = useSessionStore()
  if (!store.loaded) await store.refresh()
  if (to.meta.public) {
    if (store.user && to.name === 'login') {
      return store.isAdmin ? '/admin' : '/apps'
    }
    return true
  }
  if (!store.user) return { name: 'login', query: { redirect: to.fullPath } }
  if (to.meta.admin && !store.isAdmin) return '/apps'
  return true
})

export default router
